import { render, staticRenderFns } from "./PaperManagement.vue?vue&type=template&id=e92dee9c&scoped=true&"
import script from "./paper-management.js?vue&type=script&lang=js&"
export * from "./paper-management.js?vue&type=script&lang=js&"
import style0 from "./PaperManagement.vue?vue&type=style&index=0&id=e92dee9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92dee9c",
  null
  
)

export default component.exports